'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-dom/index.js
// module id = 24
// module chunks = 0 1